<template>
  <v-container fluid>
    <material-card
      :title="enquiryCode ? 'Edit Enquiry Form' : 'Create Enquiry Form'"
      inline
      icon="mdi-mail"
    >
      <v-card-actions>
        <router-link slot="right" :to="{ name: 'enquiry' }">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back</v-btn
          >
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon></v-btn
          >
        </router-link>
      </v-card-actions>
      <v-subheader v-if="enquiryCode"
        ><span class="font-weight-medium">Enquiry Code :</span
        ><span class="font-weight-bold">{{ enquiryCode }}</span>
      </v-subheader>
      <v-subheader class="font-weight-bold darkblue--text"
        >Assigned To:
        {{
          assignedToUser
            ? `${assignedToUser.firstName} ${assignedToUser.lastName}`
            : '-'
        }}
        (Only Enquiry owner can edit it.)</v-subheader
      >
      <!--  -->
      <form name="updateEnquiry" @submit.prevent="saveEnquiry">
        <div>
          <AdmissionElement v-model="parentdata" :formType="this.formType" />
        </div>
        <div>
          <StudentElement
            isWritable="true"
            v-model="parentdata"
            formType="enquiry"
          />
        </div>
        <div>
          <ParentElement
            v-bind:enquiryCode="enquiryCode"
            isWritable="true"
            parentType="father"
            v-model="parentdata"
            formType="enquiry"
          />
        </div>
        <div>
          <ParentElement
            isWritable="true"
            parentType="mother"
            v-model="parentdata"
            formType="enquiry"
          />
        </div>
        <div>
          <AddressElement
            isWritable="true"
            v-model="parentdata"
            formType="enquiry"
          />
        </div>
        <div>
          <EnquiryFollowupElement
            v-bind:enquiryCode="enquiryCode"
            v-model="parentdata"
          />
        </div>
        <v-card-component>
          <v-row>
            <v-col cols="12" lg="6" sm="6">
              <span class="body-2 font-weight-medium"> Message</span>
              <v-textarea
                rows="3"
                v-model="message"
                maxlength="160"
                placeholder="Write message"
                clearable
                clear-icon="mdi-close-circle"
                counter="160"
                single-line
                class="my-0 py-1"
              ></v-textarea>
            </v-col>
            <v-col cols="12" lg="6" sm="6">
              <div v-if="!enquiryCode">
                <v-checkbox
                  v-model="isSendEmail"
                  true-value="true"
                  false-value="false"
                  label="Send Email"
                ></v-checkbox>
              </div>
            </v-col>
          </v-row>
        </v-card-component>
        <v-card-actions class="d-flex justify-end">
          <v-btn
            bottom
            :disabled="hasClicked"
            right
            elevation="1"
            color="primary"
            type="submit"
          >
            <v-icon left> mdi-content-save </v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </form>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>
<script>
import constants from '@/utils/constants'
import VCardComponent from '@/components/template/VCardComponent'
import AdmissionElement from '@/components/Forms/Elements/AdmissionElement'
import StudentElement from '@/components/Forms/Elements/StudentElement'
import ParentElement from '@/components/Forms/Elements/ParentElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import MaterialCard from '@/components/template/MaterialCard'

import EnquiryFollowupElement from '@/components/Forms/Elements/EnquiryFollowupElement'
import _ from 'lodash'
import moment from 'moment'
import Utils from '@/utils'
export default {
  name: 'EnquiryForm',
  props: [
    'enquiryiD',
    'enquiryCode',
    'franchisee',
    'studentName',
    'fatherMobiles',
    'fatherName',
    'fatherEmailID',
    'fatherOccupation',
    'type',
    'admin'
  ],
  components: {
    AdmissionElement,
    StudentElement,
    ParentElement,
    EnquiryFollowupElement,
    AddressElement,
    VCardComponent,
    MaterialCard
  },
  data: function () {
    return {
      checkboxGroup: ['SMS', 'Email'],
      isLoading: false,
      enquiry: {},
      academicYears: [],
      parentdata: {},
      data: [],
      assignedToUser: null,
      hasClicked: false,
      loader: true,
      canEdit: false,
      formData: {},
      isSendEmail: false,
      message: '',
      formType: 'enquiry',
      Admin: false
    }
  },
  async created () {
    this.onstart()
    this.Admin = Utils.helper.isSuperAdmin()
    if (this.Admin) {
      this.canEdit = true
    }
  },

  methods: {
    saveEnquiry: async function () {
      if (this.parentdata.isFollowUp === 'true') {
        if (_.isEmpty(this.parentdata.followUpDateTime)) {
          this.hasClicked = false
          return this.$dialog.error({
            text: 'Please select next followup date & time',
            title: 'Error'
          })
        }
      }
      if (this.parentdata.sourceID) {
        if (this.parentdata.sourceID.length === 0) {
          this.hasClicked = false
          return this.$dialog.error({
            text: 'Please select <b>How do you come to know about us?</b>',
            title: 'Error'
          })
        }
      }

      if (this.parentdata.fatherSelect) {
        this.parentdata.pointOfContact = this.parentdata.fatherSelect
        if (_.isEmpty(this.parentdata.fatherName)) {
          this.hasClicked = false
          return this.$dialog.error({
            text: 'Please Enter Father Details',
            title: 'Error'
          })
        }
      }
      if (this.parentdata.motherSelect) {
        this.parentdata.pointOfContact = this.parentdata.motherSelect
        if (_.isEmpty(this.parentdata.motherName)) {
          this.hasClicked = false
          return this.$dialog.error({
            text: 'Please Enter Mother Details',
            title: 'Error'
          })
        }
      }
      if (this.parentdata.fatherSelect && this.parentdata.motherSelect) {
        this.parentdata.pointOfContact = 'both'
      }
      if (this.enquiryCode) {
        try {
          this.hasClicked = true
          this.loader = true
          this.parentdata.address1 = this.parentdata.address
          this.parentdata.followUpDateTime = moment(
            this.parentdata.followUpDateTime
          ).format('YYYY-MM-DD HH:mm:ss')
          const nextFollowup = this.parentdata.followUpDateTime
          const actionRemarks = this.parentdata.actionRemarks
          const enquiryResponse = this.parentdata.enquiryResponse
          const currentStatus = this.parentdata.enquiryStageID
          const isFollowUp = this.parentdata.isFollowUp
          delete this.parentdata.enquiryStageID
          delete this.parentdata.dateOfEnquiry
          delete this.parentdata.enquiryDateTime
          delete this.parentdata.isSendEmail
          delete this.parentdata.followUpDateTime
          delete this.parentdata.nextFollowup
          delete this.parentdata.actionRemarks
          delete this.parentdata.enquiryResponse
          delete this.parentdata.currentStatus
          delete this.parentdata.isFollowUp
          delete this.parentdata.message

          let formData = {
            id: this.parentdata.id,
            address1: this.parentdata.address,
            followUpDateTime: this.parentdata.followUpDateTime,
            message: this.message
          }
          delete this.parentdata.address
          _.assign(formData, this.parentdata)

          await http.put(`${constants.API_URL}/api/update-enquiry`, formData)
          if (isFollowUp === 'true') {
            const formDataFollowUps = {
              enquiryCode: this.enquiryCode,
              nextFollowup: nextFollowup,
              actionRemarks: actionRemarks,
              enquiryResponse: enquiryResponse,
              currentStatus: currentStatus
              //   franchiseeID: this.enquiryDetails.franchiseeID
            }

            await http.post(
              `${constants.API_URL}/api/addNewFollowup`,
              formDataFollowUps
            )
          }
          // let radio2 = this.radio

          if (this.type === 'Service') {
            this.$router.push({ name: 'serviceEnquiries' })
            this.$dialog.info({
              text: 'Saved successfully',
              title: 'Info'
            })
          } else {
            this.$dialog.info({
              text: 'Saved successfully',
              title: 'Info'
            })
            this.$router.push({ name: 'followupDetails', params: { enquiryCode: this.enquiryCode } })
          }
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
          this.hasClicked = false
          this.loader = false
        }
      } else {
        try {
          this.loader = true
          this.hasClicked = true
          this.loader = true
          this.parentdata.dateOfEnquiry = moment(
            this.parentdata.dateOfEnquiry
          ).format('YYYY-MM-DD HH:mm:ss')
          let formData = {
            initial: 'P',
            address1: this.parentdata.address,
            isSendEmail: this.isSendEmail,
            message: this.message,
            followUpDateTime: moment(this.parentdata.followUpDateTime).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          _.assign(formData, this.parentdata)
          delete formData.address
          delete formData.countryName
          delete formData.enquiryStageID

          const response = await http.post(
            `${constants.API_URL}/api/create-enquiry`,
            formData
          )
          if (this.parentdata.isFollowUp === 'true') {
            const formDataFollowUps = {
              enquiryCode: response.data.enquiryCode,
              nextFollowup: this.parentdata.followUpDateTime,
              actionRemarks: this.parentdata.actionRemarks,
              enquiryResponse: this.parentdata.enquiryResponse,
              currentStatus: this.parentdata.enquiryStageID
              //   franchiseeID: this.enquiryDetails.franchiseeID
            }
            await http.post(
              `${constants.API_URL}/api/addNewFollowup`,
              formDataFollowUps
            )
          }

          this.$router.push({ name: 'enquiry' })
          return this.$dialog.info({
            text: 'Enquiry created successfully',
            title: 'Info'
          })
        } catch (e) {
          const errorMessage =
            (e && e.response && e.response.data.message) || e.message
          console.log('Error While Saving Enquiry Details', errorMessage)
          return this.$dialog.error({
            text: errorMessage,
            title: 'Error'
          })
        } finally {
          this.lock = false
          this.hasClicked = false
          this.loader = false
        }
      }
    },
    childData: function (value) {
      _.assign(this.enquiry, value)
    },
    onstart: async function () {
      try {
        this.isLoading = true
        if (this.enquiryCode) {
          let response = await http.get(
            `${constants.API_URL}/api/enquiry/${this.enquiryCode}`
          )
          this.enquiryObject = response.data

          this.assignedToUser = this.enquiryObject.user
          this.parentdata = {
            id: this.enquiryObject.id,
            user: this.user,
            studentFirstName: this.enquiryObject.studentFirstName,
            studentMiddleName: this.enquiryObject.studentMiddleName,
            studentLastName: this.enquiryObject.studentLastName,
            pointOfContact: this.enquiryObject.pointOfContact,
            fatherName: this.enquiryObject.fatherName,
            fatherEmailID: this.enquiryObject.fatherEmailID,
            fatherMobile: this.enquiryObject.fatherMobile,
            fatherOccupation: this.enquiryObject.fatherOccupation,
            motherName: this.enquiryObject.motherName,
            motherEmailID: this.enquiryObject.motherEmailID,
            motherMobile: this.enquiryObject.motherMobile,
            motherOccupation: this.enquiryObject.motherOccupation,
            address1: this.enquiryObject.address1,
            city: this.enquiryObject.city,
            state: this.enquiryObject.state,
            pincode:
              this.enquiryObject.pincode === 0
                ? ''
                : this.enquiryObject.pincode,
            gender: this.enquiryObject.gender,
            classID: this.enquiryObject.classID,
            academicYearID: this.enquiryObject.academicYearID,
            franchiseeID: this.enquiryObject.franchiseeID,
            dateOfEnquiry: moment(this.enquiryObject.dateOfEnquiry).format(
              'DD/MM/YYYY HH:mm'
            ),
            enquiryDateTime: moment(this.enquiryObject.dateOfEnquiry).format(
              'YYYY-MM-DD HH:mm'
            ),
            dateOfBirth: !_.isEmpty(this.enquiryObject.dateOfBirth)
              ? moment(this.enquiryObject.dateOfBirth, 'YYYY-MM-DD').format(
                'YYYY-MM-DD'
              )
              : '',
            address: this.enquiryObject.address1,
            countryName: 'India',
            isSendEmail: false,
            isFollowUp: false,
            message: this.enquiryObject.message,
            sourceID: this.enquiryObject.sourceID,

            enquiryStageID: '',
            enquiryResponse: '',
            followUpDateTime: '',
            actionRemarks: ''
          }

          this.message = this.enquiryObject.message
          let followStage = ''
          if (!_.isEmpty(this.enquiryObject.enquiryFollowups)) {
            let followUps = this.enquiryObject.enquiryFollowups[0]
            followStage = followUps.currentStatus
          }
          this.parentdata.enquiryStageID = followStage
          this.formType = 'editEnquiry'
          this.isLoading = false
        } else {
          const { data } = await http.get(
            `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=true`
          )
          this.academicYears = data.rows
          const currentAcademicYear = Utils.getCurrentAcademicYear()
          let academicYear = this.academicYears.find((y) => {
            return y.academicYear.trim() === currentAcademicYear.trim()
          })
          const dataArray = {
            fatherMobile: this.fatherMobiles,
            fatherEmailID: this.fatherEmailID,
            fatherName: this.fatherName,
            fatherOccupation: this.fatherOccupation,
            studentFirstName: this.studentName
          }
          this.parentdata = dataArray
          this.parentdata.academicYearID = this.acadmicyear = academicYear
            ? academicYear.id
            : ''
          this.parentdata.dateOfEnquiry = ''
          this.parentdata.franchiseeID = this.franchisee
          this.parentdata.isFollowUp = false
          this.parentdata.countryName = 'India'
          this.parentdata.state = ''
          this.parentdata.enquiryStageID = ''
          this.parentdata.enquiryResponse = ''
          this.parentdata.pointOfContact = ''
          this.parentdata.actionRemarks = ''
          this.parentdata.classID = ''
          this.parentdata.gender = ''
          this.parentdata.sourceID = []
          this.parentdata.otherSourceName = ''
          this.formType = 'createEnquiry'
        }

        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.states = stateresponse.data
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    }
  }
}
</script>
